import { connect } from 'react-redux'
import ServiceEditDesignatedHotspots from 'src/components/services/edit/ServiceEditDesignatedHotspots'
import { IStoreState } from 'src/types'
import * as serviceActions from '../../state/actions/services'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const {
    service: { serviceDesignatedZone, items }
  } = state

  const serviceId = ownProps.serviceId ? ownProps.serviceId : state.service.metadata.edit.serviceId
  const { designatedHotspotsEnabled } = items[serviceId] || Number('0')

  return {
    serviceId,
    designatedHotspotsEnabled,
    designatedHotspotLocations: serviceDesignatedZone,
    formRef: ownProps.formRef,
    zoom: state.mapView.zoom,
    bounds: state.mapView.bounds,
    onStepSuccessfullyCompleted: ownProps.onStepSuccessfullyCompleted,
    onCreateServiceCompleted: ownProps.onCreateServiceCompleted
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getHotspotsList: (serviceId: string): Promise<void> => {
      return dispatch(serviceActions.fetchServiceHotspotList(serviceId))
    },
    saveLocations: (location: any, serviceId?: string) => {
      const hotspots = [...location.hotspots]
      const reconstructedHotspots = hotspots.map(loc => {
        const spot = { ...loc }
        spot.coordinates = {
          latitude: loc.coordinates.lat,
          longitude: loc.coordinates.lng
        }
        return spot
      })
      return dispatch(serviceActions.updateServiceHotspots({ hotspots: reconstructedHotspots }))
    },
    deleteHotspot: (id: string) => {
      return dispatch(serviceActions.deleteServiceDesignatedHotspot(id))
    },
    deleteDesignatedZone: (id: string) => {
      return dispatch(serviceActions.deleteServiceDesignatedZone(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditDesignatedHotspots)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditDesignatedHotspots.ts